import { Button } from '@abyss/web/ui/Button';
import { Layout } from '@abyss/web/ui/Layout';
import { Modal } from '@abyss/web/ui/Modal';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const IDLE_MILLIS = 25 * 60 * 1000;
const END_SESSION_MILLIS = 5 * 60 * 1000;
const ACTIONS = ['mousedown', 'focus', 'keydown'];

export const GuestIFPTimeoutModal = () => {
  const [isInactive, setIsInactive] = useState<boolean>(false);
  const [sessionActive, setSessionActive] = useState<boolean>(true);

  const { t } = useTranslation();

  useEffect(() => {
    const addEventListeners = (listener) => {
      ACTIONS.forEach((eventName) => {
        window.addEventListener(eventName, listener);
      });
    };

    const removeEventListeners = (listener) => {
      ACTIONS.forEach((eventName) => {
        window.removeEventListener(eventName, listener);
      });
    };
    const idleTimeout = () =>
      setTimeout(() => {
        setIsInactive(true);
        setSessionActive(true);
      }, IDLE_MILLIS);

    const logoutTimeout = () =>
      setTimeout(() => {
        setSessionActive(false);
      }, END_SESSION_MILLIS);

    let timeout = isInactive ? logoutTimeout() : idleTimeout();

    const listener = () => {
      if (!isInactive) {
        clearTimeout(timeout);
        timeout = idleTimeout();
      }
    };

    addEventListeners(listener);

    return () => {
      removeEventListeners(listener);
      clearTimeout(timeout);
    };
  }, [isInactive]);

  const handleContinue = () => {
    setIsInactive(false);
  };

  const handleEndSession = () => {
    setSessionActive(false);
  };
  if (!isInactive) {
    return null;
  }
  return (
    <Modal
      closeOnClickOutside={false}
      closeOnEscPress={false}
      hideClose={!sessionActive}
      isOpen
      onClose={handleContinue}
      size="lg"
      title={t('INACTIVITY_MODAL.TITLE')}
    >
      <Modal.Section>
        {sessionActive
          ? t('INACTIVITY_MODAL.IFPEARLYPAY_BODY_LINE_1')
          : t('INACTIVITY_MODAL.IFPEARLYPAY_BODY_LINE_3')}
      </Modal.Section>
      <Modal.Section>
        {sessionActive
          ? t('INACTIVITY_MODAL.IFPEARLYPAY_BODY_LINE_2')
          : t('INACTIVITY_MODAL.IFPEARLYPAY_BODY_LINE_4')}
      </Modal.Section>

      <Modal.Section>
        {sessionActive && (
          <Layout.Group alignLayout="right">
            <Button
              data-auto-testid="timeout-modal-end-session"
              data-testid="timeout-modal-end-session"
              onClick={handleEndSession}
              variant="outline"
            >
              {t('INACTIVITY_MODAL.END_SESSION')}
            </Button>
            <Button
              data-auto-testid="timeout-modal-continue-session"
              data-testid="timeout-modal-continue-session"
              onClick={handleContinue}
            >
              {t('INACTIVITY_MODAL.CONTINUE')}
            </Button>
          </Layout.Group>
        )}
      </Modal.Section>
    </Modal>
  );
};
